import { getIsProductionEnvironment } from './environment';
import { jsonStorage } from '@/utils/json-storage';

/**
 * Per-experiment debug overrides (managed from the debug widget, disabled in production).
 * A forced group makes the experiment behave as active for that browser: feature gating,
 * assignment reads, Segment superproperties, and `Experiment Exposed` all use the forced group.
 */
export const forcedAbTestGroupsStorageKey = 'abTestForcedGroups';

export type ForcedAbTestGroup = 'variant' | 'control';

type ForcedAbTestGroups = Partial<Record<string, ForcedAbTestGroup>>;

function readForcedAbTestGroups(): ForcedAbTestGroups {
  return jsonStorage.getItem<ForcedAbTestGroups>(forcedAbTestGroupsStorageKey) ?? {};
}

export function getForcedAbTestGroup(experimentKey: string): ForcedAbTestGroup | null {
  if (getIsProductionEnvironment()) {
    return null;
  }

  const storedGroup = readForcedAbTestGroups()[experimentKey];

  if (storedGroup !== 'control' && storedGroup !== 'variant') {
    return null;
  }

  return storedGroup;
}

export function setForcedAbTestGroup(experimentKey: string, group: ForcedAbTestGroup): void {
  jsonStorage.setItem(forcedAbTestGroupsStorageKey, {
    ...readForcedAbTestGroups(),
    [experimentKey]: group
  });
}

export function removeForcedAbTestGroup(experimentKey: string): void {
  const remainingGroups = Object.fromEntries(
    Object.entries(readForcedAbTestGroups()).filter(([key]) => key !== experimentKey)
  );

  jsonStorage.setItem(forcedAbTestGroupsStorageKey, remainingGroups);
}
